import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducers";
import ReservaSlice from "../sliceRedux/Reserva.slice";
import ValidarReservaSlice from "../sliceRedux/ValidarReserva.slice";
import CatastroSlice from "../sliceRedux/Catastro.slice";
import DocumentoSlice from "../sliceRedux/Documento.slice";

export const store = configureStore({
  middleware: [thunkMiddleware, ...getDefaultMiddleware()],
  reducer: {
    rootReducer,
    reserva: ReservaSlice,
    validar: ValidarReservaSlice,
    catastro: CatastroSlice,
    documento:DocumentoSlice
  },
});
